import { Button, UseStepContext } from '@consigli/facade';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { WizardAnalyzeButton } from '@/features/package-creation/components/wizard-analyze-button';

import { FACILITY_TYPES, useWizardContext, WizardFormData } from '../wizard-context';

interface SummaryStepProps {
  context: UseStepContext;
  onAnalyze: () => Promise<void>;
}

export const SummaryStep: FC<SummaryStepProps> = ({ context, onAnalyze }) => {
  const { t } = useTranslation();
  const { previous, hasPrevious } = context();
  const { watch } = useFormContext<WizardFormData>();
  const {
    facilityType,
    // templateMode,
    // customTemplateFile,
    // selectedCustomer,
    documentFiles,
    // gisFiles,
    urls,
  } = useWizardContext();

  // Watch form values
  const iterationName = watch('iterationName');
  const language = watch('language');
  // const employerRole = watch('employerRole');
  const selectedSiteLat = watch('selectedSiteLat');
  const selectedSiteLon = watch('selectedSiteLon');

  const selectedFacility = FACILITY_TYPES.find((f) => f.id === facilityType);
  // const selectedCustomerData = CUSTOMERS.find((c) => c.id === selectedCustomer);

  // const getTemplateDisplay = () => {
  //   if (templateMode === 'default') {
  //     return t('package-creation.template-default', { facilityType: facilityType || 'site' });
  //   }
  //   if (templateMode === 'custom' && customTemplateFile) {
  //     return customTemplateFile.name;
  //   }
  //   return '-';
  // };

  return (
    <div className="w-full">
      <p className="mt-4 mb-2 text-base font-semibold text-day-neutral-subtle">
        {t('package-creation.summary-label')}
      </p>
      <div className="space-y-2">
        <div className="flex justify-between py-2 border-b border-day-light-2">
          <span className="text-day-neutral-subtle">
            {t('package-creation.step-facility-type')}
          </span>
          <span className="text-day-neutral-dark font-medium">
            {selectedFacility ? t(selectedFacility.labelKey) : '-'}
          </span>
        </div>

        {/* <div className="flex justify-between py-2 border-b border-day-light-2">
          <span className="text-day-neutral-subtle">{t('package-creation.step-template')}</span>
          <span className="text-day-neutral-dark font-medium">{getTemplateDisplay()}</span>
        </div> */}

        {/* {facilityType === SiteDueDiligenceFacilityType.DATA_CENTER && (
          <div className="flex justify-between py-2 border-b border-day-light-2">
            <span className="text-day-neutral-subtle">{t('package-creation.step-customer')}</span>
            <span className="text-day-neutral-dark font-medium">
              {selectedCustomerData ? t(selectedCustomerData.labelKey) : '-'}
            </span>
          </div>
        )} */}

        <div className="flex justify-between py-2 border-b border-day-light-2">
          <span className="text-day-neutral-subtle">{t('package-creation.step-site-name')}</span>
          <span className="text-day-neutral-dark font-medium">{iterationName || '-'}</span>
        </div>

        <div className="flex justify-between py-2 border-b border-day-light-2">
          <span className="text-day-neutral-subtle">{t('language.select')}</span>
          <span className="text-day-neutral-dark font-medium">
            {language ? t(`language.${language.toLowerCase()}`) : '-'}
          </span>
        </div>

        {/* <div className="flex justify-between py-2 border-b border-day-light-2">
          <span className="text-day-neutral-subtle">{t('employer-role.label')}</span>
          <span className="text-day-neutral-dark font-medium">
            {employerRole ? t(`employer-role.${employerRole}`) : '-'}
          </span>
        </div> */}

        <div className="flex justify-between py-2 border-b border-day-light-2">
          <span className="text-day-neutral-subtle">{t('package-creation.step-location')}</span>
          <span className="text-day-neutral-dark font-medium">
            {selectedSiteLat && selectedSiteLon
              ? `${selectedSiteLat.toFixed(4)}, ${selectedSiteLon.toFixed(4)}`
              : '-'}
          </span>
        </div>

        <div className="flex justify-between py-2 border-b border-day-light-2">
          <span className="text-day-neutral-subtle">{t('package-creation.step-documents')}</span>
          <span className="text-day-neutral-dark font-medium">
            {documentFiles.length} {t('document-upload.files')}
          </span>
        </div>

        {/* <div className="flex justify-between py-2 border-b border-day-light-2">
          <span className="text-day-neutral-subtle">{t('package-creation.step-gis-files')}</span>
          <span className="text-day-neutral-dark font-medium">
            {gisFiles.length} {t('document-upload.files')}
          </span>
        </div> */}

        <div className="flex justify-between py-2 border-b border-day-light-2">
          <span className="text-day-neutral-subtle">{t('package-creation.step-urls')}</span>
          <span className="text-day-neutral-dark font-medium">
            {urls.length} {urls.length === 1 ? 'GIS URL' : 'GIS URLs'}
          </span>
        </div>
      </div>

      <div className="flex items-stretch gap-2 mt-6">
        {hasPrevious && (
          <Button secondary rounded onClick={previous} type="button">
            {t('package-creation.back')}
          </Button>
        )}
        <WizardAnalyzeButton localFiles={[...documentFiles]} type="button" onAnalyze={onAnalyze} />
      </div>
    </div>
  );
};
